module.exports = __webpack_public_path__ + "static/img/pay_qrpay_alipay@3x.9c80d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_alipay@3x.png
// module id = bo/q
// module chunks = 1